import { getAccessToken, getCsrfToken } from "../authClient";

function getBaseUrl() {
    const base = import.meta.env.VITE_LOCALIZATION_API_URL ?? "";
    return base.replace(/\/$/, "");
}

function buildQuery(params) {
    if (!params) return "";
    const parts = [];
    Object.entries(params).forEach(([k, v]) => {
        if (v === undefined || v === null || v === "") return;
        if (Array.isArray(v)) {
            v.forEach((x) => parts.push(`${encodeURIComponent(k)}=${encodeURIComponent(x)}`));
        } else {
            parts.push(`${encodeURIComponent(k)}=${encodeURIComponent(v)}`);
        }
    });
    return parts.length ? `?${parts.join("&")}` : "";
}

export async function localizationFetch(path, { method = "GET", params, body, headers, signal } = {}) {
    const url = `${getBaseUrl()}${path}${buildQuery(params)}`;
    const token = getAccessToken();
    const mutating = ["POST", "PUT", "PATCH", "DELETE"].includes(method.toUpperCase());
    const csrf = mutating ? getCsrfToken() : null;

    const h = new Headers(headers || {});
    if (body && !h.has("Content-Type")) h.set("Content-Type", "application/json");
    if (token && !h.has("Authorization")) h.set("Authorization", `Bearer ${token}`);
    if (csrf && !h.has("X-CSRF-Token")) h.set("X-CSRF-Token", csrf);

    const res = await fetch(url, {
        method,
        headers: h,
        body: body ? JSON.stringify(body) : undefined,
        signal,
        credentials: "include",
    });

    if (!res.ok) {
        const text = await res.text().catch(() => "");
        const err = new Error(`[SbLocalizationAPI] ${text || `${res.status} ${res.statusText}`}`);
        err.status = res.status;
        throw err;
    }

    if (res.status === 204) return null;
    const ct = res.headers.get("content-type") || "";
    return ct.includes("application/json") ? res.json() : res.text();
}
